import {
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_ERROR,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PASSWORD_RESET_REQUEST:
      return {
        requesting: true,
        successful: false,
      };

    case PASSWORD_RESET_SUCCESS:
      return {
        requesting: false,
        successful: true,
      };

    case PASSWORD_RESET_ERROR:
      return {
        requesting: false,
        successful: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/password-reset/reducer.js